export default {"src":"/_next/static/media/managu.cca3f46e.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};